import Dialog from "@components/Dialog";
import {
  setOpenOrderSucc,
  setSelectedProduct,
} from "@features/publicPage/homepage/slice";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HomePageOfferCard from "../ui/Offer/OfferCard";
import SectionHeaders from "../ui/SectionHeaders";
import PublicOrderProductDetails from "../ui/Order/Product";
import { useLoadProductsAvailableSchemePublicMutation } from "@features/publicPage/homepage/api";
import PublicOrderSchemeDetails from "../ui/Order/Scheme";
import {
  makeSelectOrderConfirmedData,
  makeSelectOrderOpenSuccess,
  makeSelectSelectedProductDetails,
} from "@features/publicPage/homepage/selectors";
import { Modal } from "@mantine/core";
import "../styles.css";
import StaticContentDiv from "@components/StaticContent";

const HomePageOfferSection = ({ section_data }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();

  const openOrderSucc = useSelector(makeSelectOrderOpenSuccess);
  const orderConfirmedData = useSelector(makeSelectOrderConfirmedData);
  const selectedProduct = useSelector(makeSelectSelectedProductDetails);

  // load products available scheme;
  const [loadScheme, { isLoading: schemeLoading, data: schemeData }] =
    useLoadProductsAvailableSchemePublicMutation();

  const handleOpen = (product) => {
    setOpen(true);
    dispatch(setSelectedProduct(product));
    // loadScheme(product._id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggleOrderSuccessPopup = () => {
    dispatch(setOpenOrderSucc(false));
  };

  if (section_data?.product_section?.product?.length > 0) {
    const productsArray = section_data.product_section.product;

    return (
      <>
        {section_data?.view_type === "Grid" && (
          <div className='bg-gray-100 py-10'>
            <div
              className={`${
                section_data.layout_class || "container mx-auto"
              } my-4`}
            >
              {section_data.is_header && (
                <SectionHeaders
                  title={
                    section_data.name || section_data.content_section?.name
                  }
                />
              )}
              <div
                className={
                  productsArray.length == 1
                    ? `lg:flex justify-center gap-8 ${section_data.class_name}`
                    : `lg:flex justify-center gap-8 ${section_data.class_name}`
                }
              >
                {productsArray.map((product) => (
                  <HomePageOfferCard
                    product={product}
                    key={product._id}
                    handleOpenScheme={() => handleOpen(product)}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
        {/* <Dialog
          opened={open}
          onClose={handleClose}
          id='order_place_modal'
          size='100%'
          // fullScreen
          className='w-screen lg:w-4/5'
          title={<b>Select Product Variant and Scheme</b>}
          closeOnClickOutside={false}
        >
          <div className='lg:grid lg:grid-cols-4 gap-2'>
            <PublicOrderProductDetails />
            <PublicOrderSchemeDetails
              schemeLoading={schemeLoading}
              schemeData={schemeData}
              handleCloseOrderPlaceModal={handleClose}
            />
          </div>
        </Dialog> */}

        <Dialog
          opened={open}
          onClose={handleClose}
          title={<b>Product Description</b>}
        >
          <div
            className='font-normal'
            dangerouslySetInnerHTML={{
              __html: selectedProduct?.productDetails?.description,
            }}
          />
        </Dialog>
        <Modal
          // withCloseButton={false}
          opened={openOrderSucc}
          styles={{
            body: {
              height: "100%",
            },
          }}
          onClose={handleToggleOrderSuccessPopup}
        >
          <div className='flex flex-col gap-2 justify-center items-center h-full'>
            <div className='checkmark__container__success'>
              <div className='shadow-lg rounded-full'>
                <svg
                  className='checkmark__success'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 52 52'
                  height='100%'
                  width='100%'
                >
                  <circle
                    className='checkmark__circle__success'
                    cx='26'
                    cy='26'
                    r='25'
                    fill='none'
                    stroke='#20ad41'
                    strokeWidth={2}
                  />{" "}
                  <path
                    className='checkmark__check__success'
                    fill='none'
                    d='M14.1 27.2l7.1 7.2 16.7-16.8'
                  />
                </svg>
              </div>
            </div>
            <div className='font-semibold'>
              Your order has been successfully placed.{" "}
            </div>
            <div className='text-center max-w-sm text-sm'>
              <span>Order ID : {orderConfirmedData?.order_id}</span>,{" "}
              <span>Name : {orderConfirmedData?.customer_name}</span> &{" "}
              <span>Phone No : {orderConfirmedData?.customer_phone}</span>
            </div>
            <div className='text-gray-600 text-sm'>
              You will be contacted later on for further details.
            </div>
            <StaticContentDiv content_key='order_success_notice' />
            <button
              className='w-1/2 my-4 text-white bg-primary p-2 rounded-md'
              onClick={handleToggleOrderSuccessPopup}
            >
              Close
            </button>
          </div>
        </Modal>
      </>
    );
  }

  return <div>HomePageOfferSection</div>;
};

export default HomePageOfferSection;
